import { useLocation } from 'react-router-dom';

import { isProd } from '@m/config/FeatureFlags';
import { useExperiment } from '@m/hooks/data/experiments';

const EXPERIMENT_NAME = 'web_express_onboarding_everywhere';
const QA_OVERRIDE_PARAM = 'agnosticOnboarding';

export type SignInOnboardingExperimentState =
  { status: 'pending' } | { status: 'control' | 'treatment' };

function qaOverride(search: string): 'control' | 'treatment' | null {
  if (isProd) return null;
  const value = new URLSearchParams(search).get(QA_OVERRIDE_PARAM);
  return value === 'control' || value === 'treatment' ? value : null;
}

export function useSignInOnboardingExperiment(): SignInOnboardingExperimentState {
  const location = useLocation();
  const override = qaOverride(location.search);
  const { data, isPending } = useExperiment(EXPERIMENT_NAME, undefined, override === null);

  if (override) return { status: override };
  if (isPending) return { status: 'pending' };
  return { status: data?.group === 'treatment' ? 'treatment' : 'control' };
}
